module.exports = __webpack_public_path__ + "img/fulTwoMob.89750ff3.svg";